/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OnPremisesMonitoringRequest {
    getFixupPrototypeFunction() { return OnPremisesMonitoringRequest.fixupPrototype; }

    static newInstance(model: Partial<OnPremisesMonitoringRequest>): OnPremisesMonitoringRequest {
        let obj = Object.assign(new OnPremisesMonitoringRequest(), model);
        OnPremisesMonitoringRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OnPremisesMonitoringRequest>): OnPremisesMonitoringRequest {
        if (!model) return null;
        return OnPremisesMonitoringRequest.newInstance(<OnPremisesMonitoringRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OnPremisesMonitoringRequest) {
        if (!obj) return;

        models.OnPremisesMonitoringRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OnPremisesMonitoringRequest): boolean {
        Object.setPrototypeOf(obj, OnPremisesMonitoringRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.from_date === "string") {
            this.from_date = new Date(<string><any>this.from_date);
        }
        if (typeof this.to_date === "string") {
            this.to_date = new Date(<string><any>this.to_date);
        }
    }

    /**
     * ID of the service account
     */
    service_account_id: string;

    /**
     * Resource identifier
     */
    resource_id: string;

    /**
     * Aggregation type (e.g., average, sum, maximum)
     */
    aggregation: string;

    /**
     * List of metric names
     */
    metric_name: Array<string>;

    /**
     * Start timestamp (ISO string or epoch). If not provided, defaults to 7 days ago.
     */
    from_date: Date;

    /**
     * End timestamp (ISO string or epoch). If not provided, defaults to now.
     */
    to_date: Date;

}
